import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

import Footer from "../Constant/Footer";
import TopBar from "../Constant/TopBar";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import * as userActions from "../../actions/index";

import DormitoryItem from "./DormitoryItem";

import DeleteConfirmRemove from "../Utility/DeleteConfirmRemove";
import Sidebar from "../Constant/sidebar";

const permission_info = JSON.parse(localStorage.getItem("permissions"));
const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
const school_code = user_info?.school_code === null || user_info === null ? "" : user_info.school_code;

const DormitoryList = (props) => {
    const dispatch = useDispatch();

    const [filterlimit, setfilterlimit] = useState(10);
    const [filterpage, setfilterpage] = useState(1);
    const [filterorder, setfilterorder] = useState("asc");
    const [filtersort, setfiltersort] = useState("dormitory_name");
    const [filtersearch, setfiltersearch] = useState(null);

    const [DormitoryList, setDormitoryList] = useState([]);
    const [DormitoryListcount, setDormitoryListcount] = useState(0);
    const [dormitory_status, setdormitory_status] = useState(true);

    const [confirm_modal, setconfirm_modal] = useState(false);
    const [deactivate_modal, setdeactivate_modal] = useState(false);
    const [students_in_dormitory, setstudents_in_dormitory] = useState([]);
    const [selected_dormitory, setselected_dormitory] = useState(null);

    const [editconfirmremovedata, seteditconfirmremovedata] = useState([]);

    const navigate = useNavigate();

    const showAddModalHandle = (event) => {
        setconfirm_modal(false);
        setdeactivate_modal(false);
    };
    
    const RemoveCourseModule = (event, course_data) => {
        seteditconfirmremovedata(course_data);
        setconfirm_modal(true);
    };

    const ConfirmRemove = (form_data) => {
        console.log('form_data===', form_data)
        setconfirm_modal(false);
        props.onDeleteDormitory(form_data).then((response) => {
            if (response.success === true) {
                GetAllListDormitory();
                toast.success(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
                // setconfirm_modal(false);
                // setdeactivate_modal(false);
            } else {
                toast.error(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        });
    };

    const ConfirmDeactivate = () => {
        if (!selected_dormitory) return;
        
        const Payload = {
            dormitory_uuid: selected_dormitory.dormitory_uuid,
            dormitory_status: false,
            dormitory_name: selected_dormitory.dormitory_name
        };
        
        props.onUpdateDormitoryStatus(Payload).then((response) => {
            if (response.success === true) {
                GetAllListDormitory();
                setfilterpage(1);
                toast.success(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
                setdeactivate_modal(false);
                setselected_dormitory(null);
            } else {
                toast.error(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        });
    };

    const GetAllListDormitory = useCallback(async () => {
        dispatch(userActions.GetAllListDormitory(filterpage, filterlimit, filtersort, filterorder, dormitory_status, filtersearch)).then((response) => {
            if (response.success === true) {
                const arrayData = response.data.rows;
                let MemberId_level = [];
                const sumvalue = 1;
                for (let key in arrayData) {
                    const perpage = ((parseInt(filterpage) - parseInt(sumvalue)) * parseInt(filterlimit) + parseInt(key) + parseInt(sumvalue));

                    MemberId_level.push({
                        perpage: perpage,
                        country_id: arrayData[key].country_id,
                        name: arrayData[key].name,
                    });
                }
                setDormitoryList(arrayData);
                setDormitoryListcount(response.data.count);
            } else if (response.status === 401) {
                toast.error(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
                setTimeout(() => {
                    navigate('/logout')
                }, 5000);
            } else {
                // Handle other errors
            }
        });
        // eslint-disable-next-line
    }, [dispatch, filterpage, filterlimit, filtersort, filterorder, dormitory_status, filtersearch]);

    useEffect(() => {
        GetAllListDormitory();
    }, [GetAllListDormitory, filterpage, filterlimit, filtersort, filterorder, dormitory_status, filtersearch]);

    const GetLoginUserPermissions = useCallback(async () => {
        dispatch(userActions.GetLoginUserPermissions()).then((response) => {
            if (response.success === true) {
                // Handle success
            } else if (response.status === 401) {
                toast.error(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
            } else {
                // Handle other errors
            }
        });
        // eslint-disable-next-line
    }, [dispatch]);
    
    useEffect(() => {
        GetLoginUserPermissions();
    }, []);

    const handleChange = async (event, dormitory_uuid, value, dormitory_name ,dormitory_id) => {
        console.log(event,"dormitory_iddormitory_id")
        // If trying to deactivate a dormitory
        if (value === false) {
            const dormitoryData = {
                dormitory_uuid: dormitory_uuid,
                dormitory_name: dormitory_name
            };
            setselected_dormitory(dormitoryData);
            
            // Check if there are any students in this dormitory
            dispatch(userActions.GetAllStudents("", "", "", "", "", "", "", dormitory_id,  "")).then((response) => {
                if (response.success === true) {
                    setstudents_in_dormitory(response.data.rows);
                    setdeactivate_modal(true);
                } else {
                    toast.error("Failed to check for students in dormitory", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
            });
        } else {
            // For activation, proceed normally
            const Payload = {
                dormitory_uuid: dormitory_uuid,
                dormitory_status: value,
                dormitory_name: dormitory_name
            };
            
            props.onUpdateDormitoryStatus(Payload).then((response) => {
                if (response.success === true) {
                    GetAllListDormitory();
                    setfilterpage(1);
                    toast.success(response.message, {
                        position: toast.POSITION.TOP_CENTER,
                    });
                } else {
                    toast.error(response.message, {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
            });
        }
    }

    return (
        <>
            {confirm_modal && (
                <DeleteConfirmRemove
                    title={`Delete Dormitory?`}
                    bodytitle="Are you sure you want to delete this Dormitory?"
                    editconfirmremovedata={editconfirmremovedata}
                    confirm_modal={confirm_modal}
                    confirmButtonText="Delete"
                    ConfirmRemove={(event) => ConfirmRemove(event)}
                    delete_confirm_modal_action={(modal_action) => showAddModalHandle(modal_action)}
                />
            )}
            
            {deactivate_modal && (
                <div className="modal fade show" id="deactivate_modal" tabIndex="-1" aria-modal="true" role="dialog" style={{ display: "block", background: "rgba(0, 0, 0, 0.5)" }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Deactivate Dormitory</h5>
                                <button type="button" className="btn-close" onClick={() => { setdeactivate_modal(false); setselected_dormitory(null); }}></button>
                            </div>
                            <div className="modal-body">
                                {students_in_dormitory.length > 0 ? (
                                    <div>
                                        <p className="text-danger fw-bold">Unable to deactivate dormitory: {selected_dormitory?.dormitory_name}</p>
                                        <p>This dormitory currently has {students_in_dormitory.length} student(s) assigned to it. You need to move these students to another dormitory before deactivating this one.</p>
                                    </div>
                                ) : (
                                    <p>Are you sure you want to deactivate dormitory: {selected_dormitory?.dormitory_name}?</p>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => { setdeactivate_modal(false); setselected_dormitory(null); }}>Cancel</button>
                                {students_in_dormitory.length === 0 && (
                                    <button type="button" className="btn btn-primary" onClick={ConfirmDeactivate}>Yes, Deactivate</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div id="kt_body" className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-fixed">
                <div className="d-flex flex-column flex-root">
                    <div className="page d-flex flex-row flex-column-fluid">
                        <Sidebar />
                        <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
                            <TopBar />
                            <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
                                <div className="post d-flex flex-column-fluid" id="kt_post">
                                    {/* <!--begin::Container--> */}
                                    <div id="kt_content_container" className="container-fluid">
                                        <div className="tab-content" id="myTabContent">
                                            <div className="tab-pane fade" id="Snapshot" role="tabpanel" aria-labelledby="Snapshot-tab"></div>

                                            <div className="tab-pane fade show active" id="Rollcall" role="tabpanel" aria-labelledby="Rollcall-tab">
                                                <div className="row">
                                                    <div className="col-lg-8">
                                                        <div className="card  tabs-outer">
                                                            <div className="card-header position-relative py-0 details-bg">
                                                                <h2 className="card-title  m-0">Dormitory Detail</h2>
                                                                <div className="card-toolbar">
                                                                    {permission_info?.add_dormitory !== false && (
                                                                        <Link to={`/${school_code}/dormitory-list/add-dormitory`} className="btn btn-sm btn-primary apply-btn add-btns addschool-button">Add Dormitory</Link>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="card-body">
                                                                <div className="card-toolbar">
                                                                    <div className="d-flex align-items-center justify-content-between mb-4">
                                                                        <div className="d-flex align-items-center position-relative">
                                                                            <span className="svg-icon svg-icon-1 position-absolute ms-4">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                                                    <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"></rect>
                                                                                    <path
                                                                                        d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                                                                                        fill="currentColor"
                                                                                    ></path>
                                                                                </svg>
                                                                            </span>

                                                                            <input 
                                                                                type="text" 
                                                                                className="form-control form-control-sm w-350px ps-12 search-out fs-6" 
                                                                                placeholder="Search " 
                                                                                style={{ background: "transparent" }}
                                                                                onChange={(event) => {
                                                                                    setfiltersearch(event.target.value);
                                                                                    setfilterpage(1);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="row">
                                                                        <div className="col-sm-12">
                                                                            <DormitoryItem
                                                                                DormitoryListcount={DormitoryListcount}
                                                                                data={DormitoryList}
                                                                                filterlimit={filterlimit}
                                                                                filterpage={filterpage}
                                                                                RemoveCourseModule={(event, data) => RemoveCourseModule(event, data)}
                                                                                propsfilterpage={(event) => setfilterpage(event)}
                                                                                handleChange={(event, dormitory_uuid, value, dormitory_name ,dormitory_id) => handleChange(event, dormitory_uuid, value, dormitory_name ,dormitory_id)}
                                                                                propsfilterlimit={(filterlimit) => {
                                                                                    setfilterlimit(filterlimit);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-4">
                                                        <div className="card ">
                                                            {/* <!--begin::Header--> */}
                                                            <div className="card-header border-bottom border-bottom-1">
                                                                <h3 className="card-title align-items-start flex-column">
                                                                    <span className="card-label fw-bold text-dark">Filters</span>
                                                                </h3>
                                                            </div>

                                                            <div className="card-body p-6">
                                                                <div className="d-flex flex-column">
                                                                    <h5>Sort By</h5>
                                                                    <div className="d-flex">
                                                                        <button 
                                                                            className={"filter-badge me-2 filter-button " + (filtersort === "dormitory_name" ? "btn btn-primary active-filter" : "btn btn-dark")}
                                                                            onClick={(event) => {
                                                                                if (filterorder === 'desc') {
                                                                                    setfilterorder('asc');
                                                                                } else {
                                                                                    setfilterorder('desc');
                                                                                }
                                                                                setfiltersort('dormitory_name');
                                                                                setfilterpage(1);
                                                                            }}
                                                                        >Name</button>

                                                                        <button 
                                                                            className={"filter-badge me-2 filter-button " + (filtersort === "created_date" ? "btn btn-primary active-filter" : "btn btn-dark")}
                                                                            onClick={(event) => {
                                                                                if (filterorder === 'desc') {
                                                                                    setfilterorder('asc');
                                                                                } else {
                                                                                    setfilterorder('desc');
                                                                                }
                                                                                setfiltersort('created_date');
                                                                                setfilterpage(1);
                                                                            }}
                                                                        >Date Added</button>
                                                                    </div>
                                                                </div>

                                                                <div className="d-flex flex-column mt-6">
                                                                    <h5>Show</h5>
                                                                    <div className="d-flex align-items-center">
                                                                        <span 
                                                                            className={"filter-badge me-2 filter-button " + (dormitory_status === "" ? "btn btn-primary active-filter" : "btn btn-dark")}
                                                                            onClick={(event) => {
                                                                                setdormitory_status('');
                                                                                setfilterpage(1);
                                                                            }}
                                                                        >All</span>
                                                                        <span 
                                                                            className={"filter-badge me-2 filter-button " + (dormitory_status === true ? "btn btn-primary active-filter" : "btn btn-dark")}
                                                                            onClick={(event) => {
                                                                                setdormitory_status(true);
                                                                                setfilterpage(1);
                                                                            }}
                                                                        >Active</span>
                                                                        <span 
                                                                            className={"filter-badge me-2 filter-button " + (dormitory_status === false ? "btn btn-primary active-filter" : "btn btn-dark")}
                                                                            onClick={(event) => {
                                                                                setdormitory_status(false);
                                                                                setfilterpage(1);
                                                                            }}
                                                                        >Inactive</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!--end::Container--> */}
                                </div>
                            </div>
                            <Footer></Footer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    onUpdateDormitoryStatus: userActions.UpdateDormitoryStatus,
    onDeleteDormitory: userActions.DeleteDormitory,
};
export default connect(mapStateToProps, mapDispatchToProps)(DormitoryList);